import { Logger } from '../../02_utils/logger';
import { SidePanelService } from './services/sidePanelService';

export class SidePanel {
  constructor(private $log: Logger, private $sidePanelService: SidePanelService) {
    const sidePanels: NodeListOf<HTMLElement> = document.querySelectorAll('[data-side-panel]');

    this.$log.debug('Filter:', sidePanels);

    if (sidePanels.length > 0) {
      this.initSidePanels();
    }
  }

  private initSidePanels(): void {
    const openSidePanelButtons: NodeListOf<HTMLElement> = document.querySelectorAll('[data-side-panel-open]');
    const closeSidePanelButtons: NodeListOf<HTMLElement> = document.querySelectorAll('[data-side-panel-close]');

    this.openSidePanelEvent();
    this.closeSidePanelEvent();

    // Open Filter Buttons throws CustomEvent => 'filter:open'
    openSidePanelButtons?.forEach((openSidePanelButton: HTMLElement) => {
      openSidePanelButton?.addEventListener('click', (event) => {
        event.preventDefault();

        const panelId: string = openSidePanelButton.dataset.sidePanelOpen;

        if (panelId) {
          document.dispatchEvent(new CustomEvent('sidePanel:open', {detail: panelId}));
        }
      });
    });

    // Close Filter Buttons throws CustomEvent => 'filter:close'
    closeSidePanelButtons?.forEach((closeSidePanelButton: HTMLElement) => {
      closeSidePanelButton?.addEventListener('click', (event) => {
        event.preventDefault();

        const panelId: string = closeSidePanelButton.dataset.sidePanelClose;

        if (panelId) {
          document.dispatchEvent(new CustomEvent('sidePanel:close', {detail: panelId}));
        }
      });
    });
  }

  /**
   * Adds custom event 'sidePanel:open' to document.
   * Opens the panel for the current uuid.
   * @returns void
   */
  public openSidePanelEvent(): void {
    document.addEventListener('sidePanel:open', async (event) => {
      const customEvent = event as CustomEvent;
      const sidePanel: HTMLElement = document.getElementById(`${customEvent.detail}`);

      this.$sidePanelService.openSidePanel(sidePanel);
      }, { passive: true });
  }

  /**
   * Adds custom event 'sidePanel:close' to document.
   * Closes the panel for the current uuid.
   * @returns void
   */
  public closeSidePanelEvent(): void {
    document.addEventListener('sidePanel:close', async (event) => {
      const customEvent = event as CustomEvent;
      const sidePanel: HTMLElement = document.getElementById(`${customEvent.detail}`);

      this.$sidePanelService.closeSidePanel(sidePanel);
    }, { passive: true });
  }
}
